import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'cm-table-row',
    templateUrl: './cm-table-row.component.html',
    styleUrls: ['./cm-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CmTableRowComponent implements OnInit {
	@Input() gridColumns: string;
	constructor() {}

	ngOnInit() {}
}
